import { gql, graphQueryBang } from "shared/lib/graphql"

const currentFragment = `
  metrics {
    new_users_TIME_PERIOD
    active_users_TIME_PERIOD
    users_with_an_applet_run_TIME_PERIOD
  }
`

const dailyFragment = `
  metrics {
    metric_date
    new_users_daily
    active_users_daily
    users_with_an_applet_run_daily
  }
`

const userMetricsQuery = gql`
  query(
    $service: String!
    $daily_metric_start_date: DataServiceDate!
    $current_metric_date: DataServiceDate!
    $comparison_metric_date: DataServiceDate!
  ) {
    daily: service_metrics(
      channel_module_name: $service
      metric_start_date: $daily_metric_start_date
      metric_end_date: $current_metric_date
    ) {
      ${dailyFragment}
    }
    current: service_metrics(
      channel_module_name: $service
      metric_start_date: $current_metric_date
      metric_end_date: $current_metric_date
    ) {
      ${currentFragment}
    }
    comparison: service_metrics(
      channel_module_name: $service
      metric_start_date: $comparison_metric_date
      metric_end_date: $comparison_metric_date
    ) {
      ${currentFragment}
    }
  }
`
// TODO: This is very gross, maybe we can simplify somehow?
export const categoryUserMetricsQuery = gql`
  query(
    $service: String!
    $daily_metric_start_date: DataServiceDate!
    $current_metric_date: DataServiceDate!
    $comparison_metric_date: DataServiceDate!
    $category_name: String
  ) {
    daily: service_metrics(
      channel_module_name: $service
      metric_start_date: $daily_metric_start_date
      metric_end_date: $current_metric_date
      category_name: $category_name
    ) {
      category_metrics {
        ${dailyFragment}
      }
    }
    current: service_metrics(
      channel_module_name: $service
      metric_start_date: $current_metric_date
      metric_end_date: $current_metric_date
      category_name: $category_name
    ) {
      category_metrics {
        ${currentFragment}
      }
    }
    comparison: service_metrics(
      channel_module_name: $service
      metric_start_date: $comparison_metric_date
      metric_end_date: $comparison_metric_date
      category_name: $category_name
    ) {
      category_metrics {
        ${currentFragment}
      }
    }
  }
`

export const worksWithUserMetricsQuery = gql`
  query(
    $service: String!
    $daily_metric_start_date: DataServiceDate!
    $current_metric_date: DataServiceDate!
    $comparison_metric_date: DataServiceDate!
    $works_with_channel_name: String
  ) {
    daily: service_metrics(
      channel_module_name: $service
      metric_start_date: $daily_metric_start_date
      metric_end_date: $current_metric_date
      works_with_channel_module_name: $works_with_channel_name
    ) {
      works_with_metrics {
        ${dailyFragment}
      }
    }
    current: service_metrics(
      channel_module_name: $service
      metric_start_date: $current_metric_date
      metric_end_date: $current_metric_date
      works_with_channel_module_name: $works_with_channel_name
    ) {
      works_with_metrics {
        ${currentFragment}
      }
    }
    comparison: service_metrics(
      channel_module_name: $service
      metric_start_date: $comparison_metric_date
      metric_end_date: $comparison_metric_date
      works_with_channel_module_name: $works_with_channel_name
    ) {
      works_with_metrics {
        ${currentFragment}
      }
    }
  }
`

const defaultMapper = data => {
  return {
    daily: data.daily.metrics,
    current: data.current.metrics,
    comparison: data.comparison.metrics,
  }
}

export const categoriesMapper = data => {
  return {
    daily:
      data.daily.category_metrics[0] && data.daily.category_metrics[0].metrics,
    current:
      data.current.category_metrics[0] &&
      data.current.category_metrics[0].metrics,
    comparison:
      data.comparison.category_metrics[0] &&
      data.comparison.category_metrics[0].metrics,
  }
}

export const worksWithMapper = data => {
  return {
    daily:
      data.daily.works_with_metrics[0] &&
      data.daily.works_with_metrics[0].metrics,
    current:
      data.current.works_with_metrics[0] &&
      data.current.works_with_metrics[0].metrics,
    comparison:
      data.comparison.works_with_metrics[0] &&
      data.comparison.works_with_metrics[0].metrics,
  }
}

const composedUserMetricsQuery = (query, timePeriodMetric) =>
  query.replace(/TIME_PERIOD/g, timePeriodMetric)

export default function userMetricsFetcher(
  serviceModuleName,
  categoryName,
  worksWithChannelName,
  {
    dailyMetricStartDate,
    currentMetricDate,
    comparisonMetricDate,
    timePeriodMetric,
  },
  mapper = defaultMapper,
  query = userMetricsQuery
) {
  return graphQueryBang(composedUserMetricsQuery(query, timePeriodMetric), {
    service: serviceModuleName,
    daily_metric_start_date: dailyMetricStartDate,
    current_metric_date: currentMetricDate,
    comparison_metric_date: comparisonMetricDate,
    category_name: categoryName,
    works_with_channel_name: worksWithChannelName,
  }).then(mapper)
}
